"use client"; // Error components must be Client Components

import { useClientTranslation } from "apps/hsr-mp/i18n";
import { useEffect } from "react";

export default function GlobalError({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  reset,
  error
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { t } = useClientTranslation("en", "errorPage");

  useEffect(() => {
    if (process.env.NODE_ENV === "development") console.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <main id="error-wrapper">
          <section className="errorBox">
            <h3 className="red">ERROR 500</h3>
            <h1 dangerouslySetInnerHTML={{ __html: t(`errorPage:sorry`) }} />
            <p
              dangerouslySetInnerHTML={{
                __html: t(`errorPage:sorryWorkingOnIt`)
              }}
            />
          </section>
        </main>
      </body>
    </html>
  );
}
